import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import cn from "classnames";

export const Content =  ({
  className = "",
  content,
  theme = "light",
}) => {
  return (
    <div className={cn(className, classes.Content)} data-bs-theme={theme}>
      <Container fluid="md">
        <Row className="flex-column flex-lg-row">
          <Col xs={12} lg={9}>
            <div className="mb-5" dangerouslySetInnerHTML={{ __html: content }} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Content;
